import { DashboardAdmin } from './dashboardAdmin';

const Dashboard = () => {
	return (
		<div>
			<DashboardAdmin />
		</div>
	);
};

export { Dashboard };
